// 状态管理
import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'underscore'
import clone from 'clone'

import api from '../api/index'
import { menus, generateRoute, handleMenus, fixedMenus } from '../config/menus'

import {LOCAL_STORAGE_KEY, LOCAL_STORAGE_KEY_NAME} from '../config/constants'

// modules
import dashboard from './modules/dashboard'
import statistics from './modules/statistics'
import {fixedMenusToC} from "@/config/menusToC";
import router from "@/router";

Vue.use(Vuex)

// states
const state = {
  captcha: '',
  captchaId: '',
  token : '' || localStorage.getItem(LOCAL_STORAGE_KEY),
  userInfo: {name: localStorage.getItem(LOCAL_STORAGE_KEY_NAME) || '',},
  permission: [],
  verify: false,
  isCollapsed: false,
  appBreakpoint: false,
  menus: [],
  errorRouter: [],
  currentPath: ''
}

// getters
const getters = {
  captcha: state => state.captcha,
  captchaId: state => state.captchaId,
  token: state => state.token,
  userInfo: state => state.userInfo,
  verify: state => state.verify,
  isCollapsed: state => state.isCollapsed,
  appBreakpoint: state => state.appBreakpoint,
  showMenu: (state) => {
    const findMenu = (menus) => {
      return _.filter(menus, (item) => {
        if (!item.meta.hide && item.list && item.list.length) {
          item.list = findMenu(item.list)
        }
        return !item.meta.hide
      })
    }
    return findMenu(clone(state.menus))
  },
  breadcrumb: (state) => {
    const breadcrumbs = []
    const group = (menus, path) => {
      return _.find(menus, (item) => {
        if (item.path === path) {
          breadcrumbs.push({
            name: item.meta.label,
            path: ''
          })
          return item.path === path
        }
        if (item.list && item.list.length) {
          let result = group(item.list, path)
          if (result) {
            return breadcrumbs.push({
              name: item.meta.label,
              path: item.path || ''
            })
          }
        }
      })
    }
    group(state.menus, state.currentPath)
    return (breadcrumbs || []).reverse()
  },
  permissionAction: (state) => {
    return (action) => {
      return _.find(state.permission, (item) => {
        return _.indexOf(item.auth.split(','), action) !== -1
      })
    }
  }
}

// mutations
const mutations = {
  updateCaptcha (state, payload) {
    state.captcha = payload
  },
  updateCaptchaId (state, payload) {
    state.captchaId = payload
  },
  updateVerify (state, payload) {
    state.verify = payload
  },
  clearAuth (state) {
    state.token = ''
    state.userInfo = null
    state.permission = []
    localStorage.removeItem(LOCAL_STORAGE_KEY)
    localStorage.removeItem(LOCAL_STORAGE_KEY_NAME)
    api.redirectToLogin()
  },
  updateToken (state, payload) {
    state.token = payload || ''
  },
  updateCollapsed (state, payload) {
    state.isCollapsed = payload
  },
  updateAppBreakpoint (state, payload) {
    state.appBreakpoint = payload
  },
  updateCurrentPath (state, payload) {
    state.currentPath = payload
  },
  updateErrorRouter (state, payload) {
    state.errorRouter = payload
  },
  updateAuthToC (state, payload) {
    if (payload.token) {
      state.token = payload.token
      localStorage.setItem(LOCAL_STORAGE_KEY, payload.token)
      localStorage.setItem(LOCAL_STORAGE_KEY_NAME, payload.user.userName || '')
    }
    state.userInfo = {
      name: payload.user.userName || '',
    }
    //初始化菜单 menu 以及对应路由
    const result = handleMenus(fixedMenusToC, [],'1' )
    router.addRoutes(generateRoute(result.menus))
    state.verify = true
  },
}

// actions
const actions = {
  login ({ commit }, res) {
    commit('updateAuthToC', res.data || {})
    // 等待路由表更新后再跳转
    Vue.nextTick(() => {
      api.redirectToHomepage()
    })
  },
  logout ({ commit }) {
    commit('clearAuth')
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    dashboard,
    statistics
  }
})
